import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Skeleton from "@mui/material/Skeleton";
import styles from "./EntityListItem.module.css";
import ListItemText from "@mui/material/ListItemText";

interface ListSkeletonItemProps {
  showSecondary?: boolean;
}

const ListSkeletonItem: React.FC<ListSkeletonItemProps> = ({
  showSecondary = true,
}) => {
  return (
    <ListItem className={styles["container"]}>
      <ListItemAvatar>
        <Avatar className={styles["avatar"]}>
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            className={styles["icon"]}
          />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        className={styles["item-text"]}
        primary={<Skeleton variant="text" width="60%" height={20} />}
        secondary={
          showSecondary ? (
            <Skeleton variant="text" width="40%" height={16} />
          ) : null
        }
      />
    </ListItem>
  );
};

export default ListSkeletonItem;
